import React, { Fragment } from "react";
import { useMedia, useToggle, useMeasure } from "react-use";

import { useHistory } from "react-router-dom";
import {
  StyledMenu,
  MenuItem,
  MenuContainer,
  Anchor,
  HButton,
  Logo,
  MenuRightSection,
} from "./styles";

const getBaseName = (location) => `/${location.pathname.split("/")[1]}`;

const HBMenu = ({ isActive, offset, setter }) => {
  const handleOff = () => {
    setter(false);
  };
  const history = useHistory();
  const getActiveState = (routeName) => {
    return history.location.pathname === routeName;
  };
  const getActiveStateFromBase = (routeName) => {
    return getBaseName(history.location) === routeName;
  };
  return (
    <MenuContainer offset={offset} active={isActive}>
      <Anchor to="/" active={getActiveState("/")} onClick={handleOff}>
        Home
      </Anchor>
      <Anchor to="/test" active={getActiveState("/test")} onClick={handleOff}>
        Teste de Perfil
      </Anchor>
      <Anchor
        to="/corrector/signin"
        active={getActiveStateFromBase("/corrector")}
        onClick={handleOff}
      >
        Área do Corretor
      </Anchor>
    </MenuContainer>
  );
};
const Nav = () => {
  const isSmall = useMedia("(max-width: 700px)");
  const [isOpened, toggle] = useToggle(false);
  const [measureRef, { height }] = useMeasure();
  // React.useEffect(() => {
  //   if (isSmall && isOpened) {
  //     toggle(false);
  //   }
  // }, [isSmall, isOpened]);
  return (
    <Fragment>
      <StyledMenu ref={measureRef} inverted>
        {isSmall ? (
          <>
            <MenuItem>
              <Logo />
            </MenuItem>
            <HButton active={isOpened} onClick={toggle} />
          </>
        ) : (
          <>
            <MenuItem to="/">
              <Logo />
            </MenuItem>
            <MenuRightSection>
              <MenuItem to="/" name="home">
                Inicio
              </MenuItem>

              <MenuItem to="/test" name="quiz">
                Teste de perfil
              </MenuItem>
              <MenuItem to="/corrector/signin" name="corretor">
                Área do corretor
              </MenuItem>
            </MenuRightSection>
          </>
        )}
      </StyledMenu>
      {isSmall && (
        <HBMenu setter={toggle} offset={height} isActive={isOpened} />
      )}
    </Fragment>
  );
};

export default Nav;
